import { AbstractPreset, config } from "./AbstractPreset";

export default class CircleNoneCustom extends AbstractPreset {
	getName(): string {
		return 'circleNoneCustom';
	}

	getConfig(): config {
		return {
			"base": {
				"shape": "circle",
				"presetShape": this.getName(),
				"primitives": {
					"diameter": 50
				},
			},
			"drillholes": {
				"type": "custom",
				"settings": [
					{
						"x": 100,
						"y": 250,
					},
					{
						"x": 220,
						"y": 150,
					},
					{
						"x": 350,
						"y": 350,
					}
				]
			},
			"cutouts": [],
		};
	}

}
